// extracted by mini-css-extract-plugin
export var closer = "MegaMenu-module--closer--xWWeo";
export var contents = "MegaMenu-module--contents--g4UmL";
export var grid = "MegaMenu-module--grid--A+sMm";
export var icon = "MegaMenu-module--icon--iZ7L8";
export var inner = "MegaMenu-module--inner--05C0g";
export var parent = "MegaMenu-module--parent--EyjHj";
export var root = "MegaMenu-module--root--D2y-T";
export var small = "MegaMenu-module--small--qUObG";
export var title = "MegaMenu-module--title--k4zWS";